<template>
  <div class="about">
    <TextHeader :title="header" />
    <PageParagraph
      :title="title"
      :sideTitle="titleSide"
      @onclickTitle="NavigateToSection"
    >
      <div
        v-for="(item, i) in paragraph"
        :key="`title-${i}`"
        class="paragraph"
        :id="item.primary.id[0].text"
      >
        <div v-if="item.primary.title">
          <TextTitle
            :animate="false"
            :inLine="true"
            :title="item.primary.title[0].text"
            fontWeight="600"
            :subTitle="true"
          />
          <div class="columns ordered-mobile" style="margin: 0px">
            <prismic-rich-text
              v-if="item.primary.info_upper"
              style="margin: 0px"
              :class="`mist-${language}-p mist-p`"
              :field="item.primary.info_upper"
            />
            <b-image class="img" :src="item.primary.img.url" />
            <prismic-rich-text
              v-if="item.primary.info_lower.length > 0"
              style="margin: 0px"
              :class="`mist-${language}-p mist-p`"
              :field="item.primary.info_lower"
            />
          </div>
        </div>
      </div>
      <TextTitle
        :animate="false"
        :title="partnerTitle"
        fontWeight="600"
        id="our-partners"
        :inLine="true"
        class="our-partner"
      />
      <div class="partner">
        <Partner :animate="false" :imgHeight="61" @onloadTitle="setTitle" />
      </div>
    </PageParagraph>
    <div class="columns" style="padding: 0.75rem 0">
      <div
        v-for="(item, i) in information"
        class="column hero is-light-blue info-card"
        :key="`${i}infoo`"
      >
        <h3 :class="`mist-${language}-h3`">{{ item.title[0].text }}</h3>
        <b-button class="mist-btn" @click="toPage(item.link[0].text)">
          {{ item.label[0].text }}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  components: {
    TextHeader: () => import(`@/components/TextHeader`),
    PageParagraph: () => import(`@/components/PageParagraph`),
    TextTitle: () => import(`@/components/TextTitle`),
    Partner: () => import(`@/components/Partner`),
  },
  data() {
    return {
      title: [],
      header: null,
      titleSide: null,
      information: [],
      paragraph: null,
      partnerTitle: null,
    };
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
  },
  watch: {
    language() {
      this.getAboutParagraph();
      this.getInfomation();
    },
  },
  mounted() {
    this.getAboutParagraph();
    this.getInfomation();
  },
  methods: {
    async getAboutParagraph() {
      this.title = [];
      this.information = [];
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["About","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.header = res.data.results[0].data.name[0].text;
      this.titleSide = res.data.results[0].data.title_side[0].text;
      this.paragraph = res.data.results[0].data.body;
      this.paragraph.forEach((arr) => {
        this.title.push(arr.primary.title[0].text);
      });
      // console.log(this.paragraph);
      const title =
        this.language === "en" ? "Our Partners" : "หน่วยงานร่วมดำเนินโครงการ";
      this.title.push(title);
      this.paragraph.push({ primary: { id: [{ text: "our-partners" }] } });
    },
    async getInfomation() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["AboutInformation","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.information = res.data.results[0].data.info;
      console.log(this.information);
      // this.information = res.data.results[0].data.body;
      // this.information = this.information.filter((i) => i.primary.button);
    },
    NavigateToSection(index) {
      const id = this.paragraph[index].primary.id[0].text;
      let offset = 106;
      if (id === "our-partners") {
        offset = 65;
      }
      $("html, body").animate(
        { scrollTop: $(`#${id}`).offset().top - offset },
        1000
      );
    },
    toPage(url) {
      if (url.startsWith("http")) {
        let win = window.open(url, "_blank");
        win.focus();
      } else {
        this.$router.push(url);
      }
    },
    setTitle(title) {
      this.partnerTitle = title;
    },
  },
};
</script>
<style>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
<style scoped>
.info-card {
  padding: 40px 60px;
  align-items: center;
  margin: 0px 10px;
}
.mist-btn {
  background-color: #0053c6;
  height: 55px;
  max-width: 211px;
  font-size: 18px;
  width: 100%;
  margin-top: 24px;
  border-radius: 0px;
  font-weight: 600;
  color: #fff;
}
.mist-p {
  text-align: left;
  padding: 30px 0px 20px !important;
}
.ordered-mobile {
  display: flex;
  flex-flow: column;
}
.paragraph {
  padding-top: 50px;
}
.our-partner {
  padding-top: 50px;
}
.partner {
  padding: 40px 0 130px;
}
.about {
  padding-bottom: 90px;
}
@media (max-width: 768px) {
  .info-card {
    padding: 30px 48px;
    align-items: center;
    margin: 10px 10px;
  }
  .paragraph {
    padding-top: 36px;
  }
  .our-partner {
    padding-top: 0px;
  }
  .partner {
    padding: 40px 0 26px;
  }
  .about {
    padding-bottom: 62px;
  }
  .mist-p {
    text-align: left;
    padding: 0px;
    order: 2;
  }
  .ordered-mobile {
    display: flex;
    flex-flow: column;
  }
  .image {
    order: 1;
    padding-top: 35px;
  }
}
</style>